import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {resource} from '@util/resource';
import {formatISO} from 'date-fns';
import {DWS} from '@interfaces/dws';
import {Gift as DwsGift, ExportGift} from '@interfaces/dws/gift';
import {WineryScheduling} from "../../interfaces/dws/winery-scheduling";
import ExperiencesTitle = WineryScheduling.ExperiencesTitle;
import { Moment } from 'moment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class GiftsService {

  constructor() {
  }

  list(wineryId: string, filters?: GiftsFilters, page: number = 0, count: number = 999999): Observable<DWS.Page<DWS.Gift>> {
    if (filters) {
      const redemptionStartTime = filters?.redemptionDate || "";
      const redemptionEndTime = filters?.redemptionDateEnd || "";
      const expirationStartTime = filters?.expirationDate || "";
      const expirationEndTime = filters?.expirationDateEnd || "";
      const creationStartTime = filters?.createdAt || "";
      const creationEndTime = filters?.createdUntil || "";

      creationStartTime
              ? (filters.createdAt = moment(creationStartTime)
                  .startOf("day")
                  .format("YYYY-MM-DD"))
              : (delete filters.createdAt);
            creationEndTime
              ? (filters.createdUntil = moment(creationEndTime)
                  .startOf("day")
                  .format("YYYY-MM-DD"))
              : (delete filters.createdUntil);
      
      redemptionStartTime
              ? (filters.redemptionDate = moment(redemptionStartTime)
                  .startOf("day")
                  .format("YYYY-MM-DD"))
              : (delete filters.redemptionDate);
            redemptionEndTime
              ? (filters.redemptionDateEnd = moment(redemptionEndTime)
                  .startOf("day")
                  .format("YYYY-MM-DD"))
              : (delete filters.redemptionDateEnd);

      expirationStartTime
              ? (filters.expirationDate = moment(expirationStartTime)
                  .startOf("day")
                  .format("YYYY-MM-DD"))
              : (delete filters.expirationDate);
            expirationEndTime
              ? (filters.expirationDateEnd = moment(expirationEndTime)
                  .startOf("day")
                  .format("YYYY-MM-DD"))
              : (delete filters.expirationDateEnd);
    }
    const appliedFilters = {
      wineryId,
      ...filters
    }
    return resource('crm://gifts')
        .params(
            {page, count, ...appliedFilters}
        )
        .get<DWS.Page<DWS.Gift>>();
  }

  getExperiencesTitle(wineryId: string): Observable<ExperiencesTitle[]> {
    return resource('crm://gifts/experiences-title')
        .params({wineryId})
        .get<ExperiencesTitle[]>();
  }

  resendEmail(giftId: string, giftEmail: string, toEmail: string): Observable<unknown> {
    return resource('crm://gifts/resend')
        .post({giftId, giftEmail, toEmail})
  }
  
  update(giftId: string, beneficiaryEmail: string, notifyAt: string | Moment, beneficiaryFirstName: string, beneficiaryLastName: string, expirationDate?: string): Observable<unknown> {
    return resource('v1://gifts/id/update')
        .params({giftId})
        .post({beneficiaryEmail, notifyAt, beneficiaryFirstName, beneficiaryLastName, expirationDate})
  }

  updateCrm(giftId: string, beneficiaryEmail: string, beneficiaryNotifyAt: string | Moment, beneficiaryFirstname: string, beneficiaryLastname: string, expiresAt: string): Observable<unknown> {
    return resource('crm://gifts/byGiftUUID/giftId')
        .params({giftId})
        .put({giftId, beneficiaryEmail, beneficiaryNotifyAt, beneficiaryFirstname, beneficiaryLastname, expiresAt})
  }

  redeem(giftId: string): Observable<unknown> {
    return resource('crm://v2/gifts/giftId/redeem')
        .params({giftId})
        .post();
  }

  redemptionPreview(giftId: string): Observable<GiftRedemptionPreview> {
    return resource('crm://v2/gifts/giftId/redemption-preview')
        .params({giftId})
        .get<GiftRedemptionPreview>();
  }

  putStaffNote(giftId: string, note: string): Observable<DwsGift> {
    return resource('crm://v2/gifts/giftId/staff-note')
        .params({giftId})
        .put({note});
  }

  sendNow(giftId: string, toEmail: string): Observable<unknown> {
    return resource('v1://gifts/id/send_manual_email')
        .params({giftId})
        .post({toEmail})
  }

  getGiftById(giftId: string): Observable<DWS.Gift> {
    return resource('crm://gifts/id')
        .params({id: giftId})
        .get<DWS.Gift>();
  }

  giftsToExport(wineryId: string, filters: GiftsFilters): Observable<ExportGift[]> {
    return resource('crm://gifts/export')
        .params({
          wineryId,
          ...filters
        })
        .get<ExportGift[]>()
  }

  getPDF(wineryId: string, giftId: string, langCode: string): Observable<Blob> {
    return resource('crm://gifts/create-voucher')
        .params({
          giftId,
          langCode,
          wineryId,
        })
        .get("blob")
  }

}

export interface GiftRedemptionPreviewAnomaly {
  code: string;
  messageIt?: string;
  messageEn?: string;
}

export interface GiftRedemptionPreview {
  anomalies?: GiftRedemptionPreviewAnomaly[];
  giftExpired?: boolean;
  blockingForCustomer?: boolean;
  blockingCodes?: string[];
}

export interface GiftsFilters {
  giftId?: string;
  experienceId?: string;
  buyerName?: string;
  beneficiaryName?: string;
  excludeStates?: string[];
  createdAt?: string | Date;
  createdUntil?: string | Date;
  redemptionDate?: string | Date;
  redemptionDateEnd?: string | Date;
  expirationDate?: string | Date;
  expirationDateEnd?: string | Date;
  experienceDate?: string | Date;
  experienceDateEnd?: string | Date;
  redeemLink?: string;
  startTime?: string | Date;
  endTime?: string | Date;
  
  dateRangeCreation?: { start: string; end: string };
  dateRangeRedemption?: { start: string; end: string };
  dateRangeExpiration?: { start: string; end: string };
  dateRangeExperience?: { start: string; end: string };
}
